import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

const Navigation = (props) => {
    const [isServicesMenuOpen, setIsServicesMenuOpen] = useState(false);
    const location = useLocation(); // 👈 gets the current path

    // Automatically determines the active route
    const getActiveItem = () => {
        const path = location.pathname;

        if (path === '/') return 'home';
        if (path.startsWith('/about')) return 'about';
        if (path.startsWith('/services')) return 'services';
        if (path.startsWith('/post-image')) return 'updates';
        if (path.startsWith('/project-grid')) return 'deals';
        if (path.startsWith('/post-gallery')) return 'gallery';
        if (path.startsWith('/contactus')) return 'contact';
        return '';
    };

    const activeItem = getActiveItem();

    useEffect(() => {
        const loadScript = (src) => {
            return new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', resolve);
                script.addEventListener('error', reject);
                document.body.appendChild(script);
                document.body.removeChild(script);
            });
        };

        loadScript('./assets/js/masonary.js');
    }, []);

    return (
        <div className={props.bgcolor !== '' ? `header-nav navbar-collapse collapse ${props.bgcolor}` : 'header-nav navbar-collapse collapse'}>
            <ul className="nav navbar-nav">
                <li className={activeItem === 'home' ? 'active' : ''}>
                    <NavLink to="/">Home</NavLink>
                </li>
                <li className={activeItem === 'about' ? 'active' : ''}>
                    <NavLink to="/about">About us</NavLink>
                </li>
                <li className={activeItem === 'services' ? 'active' : ''}>
                    <NavLink
                        to="#"
                        onClick={(e) => {
                            e.preventDefault();
                            setIsServicesMenuOpen(prev => !prev);
                        }}
                    >
                        Services
                        <i className={`fa ${isServicesMenuOpen ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                    </NavLink>
                    <ul className={`sub-menu ${isServicesMenuOpen ? 'open' : ''}`}>
                        <li><NavLink to="/services">Wardrobes</NavLink></li>
                        <li>
                            <NavLink to="#">Home Office</NavLink>
                            <ul className={`sub-menu ${isServicesMenuOpen ? 'open' : ''}`}>
                                <li><NavLink to="/services">Bookshelves</NavLink></li>
                                <li><NavLink to="/services">Storage Units</NavLink></li>
                                <li><NavLink to="/services">Study</NavLink></li>
                            </ul>
                        </li>
                        <li><NavLink to="/services">Kitchen</NavLink></li>
                        <li><NavLink to="/services">Media Wall</NavLink></li>
                        <li><NavLink to="/services">Loft Conversion</NavLink></li>
                        <li><NavLink to="/services">Understairs and More</NavLink></li>
                    </ul>
                </li>
                <li className={activeItem === 'updates' ? 'active' : ''}>
                    <NavLink to="/post-image">Blog & Updates</NavLink>
                </li>
                {/* <li className={activeItem === 'deals' ? 'active' : ''}>
                    <NavLink to="/project-grid">Deals</NavLink>
                </li> */}
                <li className={activeItem === 'gallery' ? 'active' : ''}>
                    <NavLink to="/post-gallery">Gallery</NavLink>
                </li>
                <li className={activeItem === 'contact' ? 'active' : ''}>
                    <NavLink to="/contactus">Contact us</NavLink>
                </li>
            </ul>
        </div>
    );
};

export default Navigation;
